import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import aiInterviewHero from '../../../../assets/images/login/ai_interview_hero.png';
import aiTechBackground from '../../../../assets/images/login/ai_tech_background.png';
import aiRobotAssistant from '../../../../assets/images/login/ai_robot_assistant.png';

export default function AIInterviewTheme({
  title, description }) {
  return (
    <div className="col-lg-8 d-none d-lg-block p-0 position-relative">
      <div
        className="h-100 w-100 position-relative d-flex align-items-center justify-content-center overflow-hidden"
        style={{
          background: `linear-gradient(135deg, rgba(14, 165, 233, 0.95) 0%, rgba(217, 70, 239, 0.95) 100%)`,
          borderRadius: '0 2rem 2rem 0'
        }}
      >
        {/* Animated Background Image */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${aiTechBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.2,
          animation: 'slowZoom 20s ease-in-out infinite alternate'
        }} />

        {/* Floating Particles */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '100px',
          height: '100px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 6s ease-in-out infinite'
        }} />
        <div style={{
          position: 'absolute',
          bottom: '15%',
          right: '15%',
          width: '150px',
          height: '150px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          filter: 'blur(50px)',
          animation: 'float 8s ease-in-out infinite 2s'
        }} />
        <div style={{
          position: 'absolute',
          top: '50%',
          right: '5%',
          width: '80px',
          height: '80px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          filter: 'blur(30px)',
          animation: 'float 7s ease-in-out infinite 1s'
        }} />

        {/* Content Container */}
        <div className="text-center text-white p-5 position-relative" style={{ zIndex: 1 }}>
          {/* Hero Image with Glassmorphism Card */}
          <div style={{
            margin: '0 auto 2.5rem',
            maxWidth: '500px',
            background: 'rgba(255, 255, 255, 0.15)',
            backdropFilter: 'blur(20px)',
            borderRadius: '2rem',
            padding: '2rem',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            animation: 'fadeInScale 1s ease-out'
          }}>
            <img
              src={aiInterviewHero}
              alt="AI Interview Platform"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '1rem',
                animation: 'gentleFloat 4s ease-in-out infinite'
              }}
            />
          </div>

          {/* Title and Description */}
          <h1 style={{
            marginBottom: '1rem',
            fontSize: '2.5rem',
            fontWeight: '800',
            fontFamily: 'Poppins, sans-serif',
            background: 'linear-gradient(90deg, #06b6d4 0%, #8b5cf6 33%, #ec4899 66%, #fbbf24 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: 'none',
            filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3))',
            animation: 'fadeInUp 1s ease-out 0.2s both'
          }}>
            {title}
          </h1>
          <p style={{
            opacity: '0.95',
            maxWidth: '550px',
            margin: '0 auto 2.5rem',
            fontSize: '1.1rem',
            lineHeight: '1.6',
            fontFamily: 'Inter, sans-serif',
            textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
            animation: 'fadeInUp 1s ease-out 0.4s both'
          }}>
            {description}
          </p>

          {/* Feature Cards with Icons */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1.5rem',
            maxWidth: '600px',
            margin: '0 auto',
            animation: 'fadeInUp 1s ease-out 0.6s both'
          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              borderRadius: '1rem',
              padding: '1.5rem 1rem',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 30px -10px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                background: 'rgba(255, 255, 255, 0.25)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                fontSize: '1.5rem'
              }}>
                <i className="bi bi-shield-check" style={{ color: 'white' }}></i>
              </div>
              <p style={{
                margin: 0,
                fontWeight: '600',
                fontSize: '0.95rem',
                fontFamily: 'Poppins, sans-serif'
              }}>Secure & Safe</p>
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              borderRadius: '1rem',
              padding: '1.5rem 1rem',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 30px -10px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                background: 'rgba(255, 255, 255, 0.25)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                fontSize: '1.5rem'
              }}>
                <i className="bi bi-cpu" style={{ color: 'white' }}></i>
              </div>
              <p style={{
                margin: 0,
                fontWeight: '600',
                fontSize: '0.95rem',
                fontFamily: 'Poppins, sans-serif'
              }}>AI-Powered</p>
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              borderRadius: '1rem',
              padding: '1.5rem 1rem',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 30px -10px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                background: 'rgba(255, 255, 255, 0.25)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                fontSize: '1.5rem'
              }}>
                <i className="bi bi-lightning-charge" style={{ color: 'white' }}></i>
              </div>
              <p style={{
                margin: 0,
                fontWeight: '600',
                fontSize: '0.95rem',
                fontFamily: 'Poppins, sans-serif'
              }}>Lightning Fast</p>
            </div>
          </div>

          {/* Robot Assistant - Miro - Floating at Top */}
          <div style={{
            position: 'absolute',
            top: '2rem',
            right: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            animation: 'randomWander 25s ease-in-out infinite',
            opacity: 0.9
          }}>
            <img
              src={aiRobotAssistant}
              alt="Miro - AI Assistant"
              style={{
                width: '120px',
                height: '120px',
                objectFit: 'contain',
                filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3))'
              }}
            />
            <p style={{
              color: 'white',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '700',
              fontSize: '1rem',
              marginTop: '0.5rem',
              marginBottom: 0,
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
              letterSpacing: '0.5px'
            }}>Miro</p>
          </div>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { 
            transform: translateY(0px); 
          }
          50% { 
            transform: translateY(-20px); 
          }
        }

        @keyframes gentleFloat {
          0%, 100% { 
            transform: translateY(0px) rotate(0deg); 
          }
          50% { 
            transform: translateY(-15px) rotate(2deg); 
          }
        }
        
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slowZoom {
          from {
            transform: scale(1);
          }
          to {
            transform: scale(1.1);
          }
        }

        @keyframes randomWander {
          0% {
            transform: translate(0, 0) rotate(0deg);
          }
          12% {
            transform: translate(30px, -20px) rotate(5deg);
          }
          25% {
            transform: translate(50px, 15px) rotate(-3deg);
          }
          37% {
            transform: translate(20px, 40px) rotate(8deg);
          }
          50% {
            transform: translate(-15px, 30px) rotate(-5deg);
          }
          62% {
            transform: translate(-40px, -10px) rotate(6deg);
          }
          75% {
            transform: translate(-30px, -35px) rotate(-4deg);
          }
          87% {
            transform: translate(10px, -40px) rotate(3deg);
          }
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
        }
      `}</style>
    </div>
  );
}